import {
  AtprotoDohHandleResolver,
  BrowserOAuthClient,
} from "@atproto/oauth-client-browser";

// core-oauth-client enforces 127.0.0.1 for loopback clients to avoid ambiguity
const publicURL = window.location.origin;

// Check if we are running in production (bundled) or development
const isProduction = !publicURL.includes("127.0.0.1");

export const clientMetadataHref = `${publicURL}/oauth-client-metadata.json`;
const redirectURI = `${publicURL}/callback`;

const handleResolver = new AtprotoDohHandleResolver({
  dohEndpoint: "https://cloudflare-dns.com/dns-query",
});
const scopes = ["atproto", "transition:generic"];

export const client = new BrowserOAuthClient({
  handleResolver,
  clientMetadata: {
    // client_id must be "http://localhost" for loopback exception
    // BUT the redirect_uri inside it must match the actual origin (127.0.0.1)
    client_id: isProduction
      ? clientMetadataHref
      : `http://localhost?redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(scopes.join(" "))}`,
    client_name: "Atarashii",
    client_uri: publicURL,
    logo_uri: `${publicURL}/logo.svg`,
    tos_uri: `${publicURL}/tos`,
    policy_uri: `${publicURL}/privacy`,
    redirect_uris: [redirectURI],
    scope: scopes.join(" "),
    grant_types: ["authorization_code", "refresh_token"],
    response_types: ["code"],
    application_type: "web",
    token_endpoint_auth_method: "none",
    dpop_bound_access_tokens: true,
  },
});
